import Alert from '@r1-frontend/ui-react/components/Alert';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { useContextSelector } from '~/src/entities/speed-bonus/context/hooks';

import HowToPrepare from './components/HowToPrepare';
import TimeSlots from './containers/TimeSlots';

const TimeSlotsPage = (): JSX.Element => {
    const result = useContextSelector(state => state.result);

    return (
        <FullWidthListContainer $size={24} $direction={'column'}>
            {result.target === 'alert' && (
                <Alert type={'success'}>
                    <Paragraph4 dangerouslySetInnerHTML={{ __html: `${result.header} ${result.message}` }}/>
                </Alert>
            )}

            <TextWrapper $lastIndent={false}>
                <H3>Выберите дату подключения</H3>
                <Paragraph4>Инженер подключит и&nbsp;настроит оборудование примерно за&nbsp;60&nbsp;минут. <HowToPrepare/></Paragraph4>
            </TextWrapper>

            <TimeSlots/>
        </FullWidthListContainer>
    );
};

export default TimeSlotsPage;
